/**
 * Mirrors PHP:
 *   $ts = strtotime($customerInfo['joinDate'] ?? date('m/d/y H:i'));
 *   $showRenew = (time() - $ts) > 86400;
 * Missing join date uses "now", so the member is treated as within the first 24 hours.
 */
const DAY_MS = 86400000;

/**
 * @param {string | number | null | undefined} joinDateRaw
 * @returns {number} epoch milliseconds for the join instant
 */
export function joinTimestampMs(joinDateRaw) {
  if (joinDateRaw == null) {
    return Date.now();
  }
  const s = String(joinDateRaw).trim();
  if (!s) {
    return Date.now();
  }
  if (typeof joinDateRaw === 'number' && Number.isFinite(joinDateRaw)) {
    const n = joinDateRaw < 1e12 ? joinDateRaw * 1000 : joinDateRaw;
    return Number.isFinite(n) ? n : Date.now();
  }

  let ts = Date.parse(s);
  if (!Number.isNaN(ts)) {
    return ts;
  }

  const mdy = s.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
  );
  if (mdy) {
    const month = parseInt(mdy[1], 10) - 1;
    const day = parseInt(mdy[2], 10);
    let year = parseInt(mdy[3], 10);
    if (year < 100) {
      year += year >= 70 ? 1900 : 2000;
    }
    const hh = mdy[4] != null ? parseInt(mdy[4], 10) : 0;
    const mm = mdy[5] != null ? parseInt(mdy[5], 10) : 0;
    const ss = mdy[6] != null ? parseInt(mdy[6], 10) : 0;
    ts = new Date(year, month, day, hh, mm, ss).getTime();
    if (!Number.isNaN(ts)) {
      return ts;
    }
  }

  return Date.now();
}

/**
 * @param {string | number | null | undefined} joinDateRaw
 * @returns {boolean}
 */
export function computeShowRenewFromJoinDate(joinDateRaw) {
  const joinMs = joinTimestampMs(joinDateRaw);
  return Date.now() - joinMs > DAY_MS;
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/NfibSiteChrome/nfibJoinRenewUtils.js